import React from 'react';
import { ArrowRight, Recycle, Wallet, Users, BarChart3 } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const highlights = [
    { icon: Recycle, label: 'Pengelolaan Sampah' },
    { icon: Wallet, label: 'Saldo Digital' },
    { icon: Users, label: 'Multi-Role System' },
    { icon: BarChart3, label: 'Transparansi Penuh' },
  ];

  return (
    <div className="relative pt-24 pb-20 overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-emerald-400/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-teal-400/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-emerald-100 dark:bg-emerald-900/30 px-4 py-2 rounded-full mb-8 border border-emerald-200 dark:border-emerald-800">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-600"></span>
            </span>
            <span className="text-sm font-semibold text-emerald-700 dark:text-emerald-300">
              Dokumentasi Sistem Terbaru
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            <span className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 dark:from-white dark:via-slate-100 dark:to-white bg-clip-text text-transparent">
              Bank Sampah Digital
            </span>
          </h1>

          {/* Tagline */}
          <p className="text-xl sm:text-2xl font-semibold text-emerald-600 dark:text-emerald-400 mb-6">
            Solusi Digital Terintegrasi untuk Pengelolaan Sampah dan Keuangan Berkelanjutan
          </p>

          {/* Description */}
          <p className="text-lg text-slate-600 dark:text-slate-400 mb-12 max-w-3xl mx-auto leading-relaxed">
            Platform terintegrasi yang dirancang untuk mengelola proses pengumpulan sampah, transaksi saldo, distribusi dana, serta kolaborasi antara nasabah, petugas, rekanan, dan admin secara transparan, efisien, dan terdokumentasi dengan baik.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
            <Button
              size="lg"
              onClick={() => scrollToSection('roles')}
              className="bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white px-8 py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group"
            >
              Jelajahi Dokumentasi
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => scrollToSection('workflow')}
              className="px-8 py-6 text-lg rounded-xl border-2 border-slate-300 dark:border-slate-700 hover:border-emerald-500 dark:hover:border-emerald-500 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 transition-all duration-300"
            >
              Lihat Alur Proses
            </Button>
          </div>

          {/* Highlights */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            {highlights.map((item, index) => (
              <div
                key={index}
                className="group bg-white dark:bg-slate-900 rounded-2xl p-6 shadow-md hover:shadow-xl border border-slate-200 dark:border-slate-800 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="bg-gradient-to-br from-emerald-500 to-teal-600 w-12 h-12 rounded-xl flex items-center justify-center mb-4 mx-auto group-hover:scale-110 transition-transform duration-300">
                  <item.icon className="h-6 w-6 text-white" />
                </div>
                <p className="text-sm font-semibold text-slate-700 dark:text-slate-300">
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;